import client from "../../client";

export function getContracts() {
  return client.get("/api/v2/contracts");
}
